import { formatDate } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { EditorBookingItemSettingBookingWindow } from '../editor-booking-item-setting/editor-booking-item-setting-booking-window.model';


@Component({
    selector: 'eas-editor-booking-item-setting-summary-booking-window',
    templateUrl: './editor-booking-item-setting-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingSummaryBookingWindowComponent implements OnChanges, OnInit {
  @Input() itemSetting: EditorBookingItemSettingBookingWindow;
  @Input() first: boolean;
  @Input() last: boolean;

  summary: string;

  constructor(@Inject(LOCALE_ID) private locale: string) {

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSetting) {
      this.summary = this.getSummary();
    }
  }

  getSummary(): string {
    const formattedOpen = this.itemSetting.open === null ? null : formatDate(this.itemSetting.open.toDate(), 'short', this.locale);
    const formattedDateOpen = this.itemSetting.open === null ? null : formatDate(this.itemSetting.open.toDate(), 'shortDate', this.locale);
    const formattedTimeOpen = this.itemSetting.open === null ? null : formatDate(this.itemSetting.open.toDate(), 'shortTime', this.locale);
    const formattedClose = this.itemSetting.close === null ? null : formatDate(this.itemSetting.close.toDate(), 'short', this.locale);
    const formattedDateClose = this.itemSetting.close === null ? null : formatDate(this.itemSetting.close.toDate(), 'shortDate', this.locale);
    const formattedTimeClose = this.itemSetting.close === null ? null : formatDate(this.itemSetting.close.toDate(), 'shortTime', this.locale);

    let summary: string;
    if (this.itemSetting.open !== null && this.itemSetting.close !== null) {
      summary = (formattedDateOpen === formattedDateClose)
        ? $localize `booking window on ${formattedDateOpen}, from ${formattedTimeOpen} to ${formattedTimeClose}`
        : $localize `booking window from ${formattedOpen} to ${formattedClose}`;
    } else if (this.itemSetting.open !== null) {
      summary = $localize `booking window from ${formattedOpen}`;
    } else if (this.itemSetting.close) {
      summary = $localize `booking window until ${formattedClose}`;
    }

    if (summary === undefined) {
      return '';
    }

    if (this.itemSetting.timezone !== null) {
      summary = `${summary} ${this.itemSetting.timezone}`;
    }

    summary = this.first ? summary.charAt(0).toUpperCase() + summary.slice(1) : summary;
    if (!this.last) {
      summary = `${summary}, `;
    }

    return summary;
  }
}
